import * as Yup from 'yup';
import { MAX_SBP_TRANSFER_AMOUNT } from '@constants/common';

export const getValidationSchema = () =>
    Yup.object({
        amount: Yup.number()
            .test({
                name: 'is-empty',
                test: Boolean,
            })
            .max(MAX_SBP_TRANSFER_AMOUNT),
    });
